import * as React from 'react';
import { Component } from 'react';
import propz from 'propz';
import { AppUser } from 'Src/views/App/App';
import { History } from 'history';
import { GmEmailTemplateForm, GmEmailTemplateSettings } from 'Src/components/GmEmailTemplateForm/GmEmailTemplateForm';
import { updateSchoolSettings } from 'Src/helpers/service/admin/settings';
import { SchoolSettingsTabs } from '../SchoolSettings/SchoolSettingsTabs';
import './GmEmailSettings.scss';

interface Props {
  user: AppUser;
  history: History;
  onSchoolUpdate: () => Promise<any>;
}

interface State {
  isSaving: boolean;
  errorMessage: string;
  successMessage: string;
}

export class GmEmailSettings extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      isSaving: false,
      errorMessage: '',
      successMessage: ''
    };
  }

  onSave = (settings: GmEmailTemplateSettings) => {
    const { user, onSchoolUpdate } = this.props;

    this.setState({ isSaving: true, errorMessage: '', successMessage: '' });

    updateSchoolSettings(user, settings)
      .then(() => onSchoolUpdate())
      .then(() => {
        this.setState({ isSaving: false, successMessage: 'Email template settings saved.' });
      })
      .catch(() => {
        this.setState({ isSaving: false, errorMessage: 'Failed to save settings. Please try again.' });
      });
  };

  render() {
    const { user } = this.props;
    const { isSaving, errorMessage, successMessage } = this.state;

    const school = propz.get(user, ['activeSchool'], {});
    const schoolName = propz.get(school, ['name'], '');
    const schoolLogo =
      propz.get(school, ['pic'], '') || propz.get(school, ['logoUrl'], '') || propz.get(school, ['logo'], '');

    const settings: GmEmailTemplateSettings = {
      gmEmailHeaderColor: propz.get(school, ['gmEmailHeaderColor'], '#1e3a5f'),
      gmEmailHeaderEnabled: propz.get(school, ['gmEmailHeaderEnabled'], true),
      gmEmailHeaderLogoEnabled: propz.get(school, ['gmEmailHeaderLogoEnabled'], true),
      gmEmailHeaderNameEnabled: propz.get(school, ['gmEmailHeaderNameEnabled'], true),
      gmEmailHeaderLogoAlignment: propz.get(school, ['gmEmailHeaderLogoAlignment'], 'left'),
      gmEmailHeaderNamePlacement: propz.get(school, ['gmEmailHeaderNamePlacement'], 'below'),
      gmEmailHeaderNameAlignment: propz.get(school, ['gmEmailHeaderNameAlignment'], 'left'),
      gmEmailFooterHtml: propz.get(school, ['gmEmailFooterHtml'], ''),
      gmEmailFooterBackgroundColor: propz.get(school, ['gmEmailFooterBackgroundColor'], '#f8f9fa'),
      gmEmailFooterTextColor: propz.get(school, ['gmEmailFooterTextColor'], '#64748b'),
      gmEmailFooterAlignment: propz.get(school, ['gmEmailFooterAlignment'], 'left')
    };

    return (
      <div className="schoolSettingsPage gmEmailSettingsPage">
        <header className="schoolSettingsHeader">
          <h1>School settings</h1>
          <SchoolSettingsTabs />
        </header>

        {errorMessage && <div className="schoolSettingsAlert schoolSettingsAlert--danger">{errorMessage}</div>}
        {successMessage && <div className="schoolSettingsAlert schoolSettingsAlert--success">{successMessage}</div>}

        <div className="gmEmailSettings__brandingHeading">
          <h3>Branded email template</h3>
        </div>
        <GmEmailTemplateForm
          user={this.props.user}
          settings={settings}
          schoolName={schoolName}
          schoolLogo={schoolLogo}
          isSaving={isSaving}
          onSave={this.onSave}
        />
      </div>
    );
  }
}
